import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePage from '../views/HomePage.vue'
import NGuest from '../views/NGuest.vue';
import Precheckin from '../views/Precheckin.vue';


Vue.use(VueRouter)

  const routes = [
    {
      path: '/',
      name: 'dashboard',
      component: () => import(/* webpackChunkName: "about" */ '../views/Dashboard.vue')
    },
    {
      path: '/home',
      name: 'home',
      component: () => import(/* webpackChunkName: "about" */ '../views/Dashboard.vue')
      //component: HomePage,
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: HomePage,
    },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue'),
    },
    {
      path: '/home/:reservationid',
      name: 'home',
      component: () => import(/* webpackChunkName: "about" */ '../views/Dashboard.vue')
      //component: HomePage,
    },
    {
      path: '/checkin/:reservationid',
      name: 'checkin',
      component: HomePage,
    },
    {
      path: '/nguest/:reservationid',
      name: 'nguest',
      props: true,
      component: NGuest,
    },
    {
      path: '/precheckin',
      name: 'precheckin',
      component: Precheckin,
    },
    {
      path: '/precheckin/:reservationid',
      name: 'Check-in online diretto',
      component: Precheckin,
    },
    {
      path: '/bye',
      name: 'bye',
      component: () => import(/* webpackChunkName: "about" */ '../views/Bye.vue')
    },
    {
      path: '/ristomenu',
      name: 'ristomenu',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ '../views/RistoMenu.vue')
    },
    {
      path: '/ristomenu/:reservationid',
      name: 'ristomenupren',
      component: () => import(/* webpackChunkName: "about" */ '../views/RistoMenu.vue')
    },
    {
      path: '/directmenu/:guidmenu',
      name: 'directmenu',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ '../views/RistoMenu.vue')
    },
    {
      path: '/ec',
      name: 'estrattoconto',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ '../views/EstrattoConto.vue')
    },
    {
      path: '/msg',
      name: 'messaggi',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ '../views/Messages.vue')
    },
    {
      path: '/about',
      name: 'About',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    },
    {
      path: '/firma',
      name: 'firma',
        component: () => import(/* webpackChunkName: "about" */ '../views/Firma.vue')
    },
    {
      path: '/utils',
      name: 'utils',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ '../views/Utils.vue')
    },
    {
      path: '/docs',
      name: 'docs',
      component: () => import(/* webpackChunkName: "about" */ '../views/Documenti.vue')
    },
    {
      path: '/info',
      name: 'info',
      component: () => import(/* webpackChunkName: "about" */ '../views/Info.vue')
    },
    {
      path: '/pags',
      name: 'pags',
      component: () => import(/* webpackChunkName: "about" */ '../views/Pagamenti.vue')
    },
    {
      path: '/blog',
      name: 'blog',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ '../views/Bacheca.vue')
    },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
